export const METRICS_RESPONSE_CODES = {
  // 404
  priceHistoryNotFound: 'BOLT-ME-404-001'
} as const
